interface ITime {
  hours: number;
  minutes: number;
  seconds: number;
  days: number;
}

export const getCountdown: (time: ITime) => string = ({ days, hours, minutes, seconds }) => {
  const formatTime = (time: number) => (time < 10 ? `0${time}` : `${time}`);

  if (days < 1) {
    return `${formatTime(hours)}:${formatTime(minutes)}:${formatTime(seconds)}`;
  }

  return `${formatTime(days)}:${formatTime(hours)}:${formatTime(minutes)}:${formatTime(seconds)}`;
};
